function isLocalHost(hostname = window.location.hostname) {
  return ["localhost", "127.0.0.1", "", "::1"].includes(hostname);
}

function createLinkConfig() {
  let linkConfig = {
    web: "/",
    h5: "/",
    online:
      "https://shunlong.s5.udesk.cn/im_client/?web_plugin_id=4018&group_id=1046",
    login: "https://fo.fdduser.com/Frontoffice/",
    disclaimer: "https://www.fdgjs.com/disclaimer.html",
    risk: "/risk_disclosure",
    agreement: "/client_agreement",
    policy: "https://www.fdgjs.com/yinsi.html",
    ios: "https://apps.apple.com/cn/app/id6746117108",
    android: [
      "https://downloads.fudedeauce.com/source/material/FDFD_tuijian.apk",
    ],
    android_backup:
      "https://mp-18b59665-8ace-4294-a961-e5d5164f6bef.cdn.bspapp.com/GW/2025.3/FDFD_GW_v291.apk",
  };

  /**
   * 本地开发或者UAT 设定:
   * isLocalHost() || window.location.hostname.includes("atbgovernor")
   *
   * 其余视为正式环境，动态域名
   */
  if (isLocalHost() || window.location.hostname.includes("atbgovernor")) {
    linkConfig.web = "https://wasin.atbgovernor.com";
    linkConfig.h5 = "http://h5-wasin-official.atbgovernor.com/?utm_source=tuijian";
  } else {
    const baseDomain = window.location.hostname.replace(/^[^.]+\./, '');
    linkConfig.h5 = `${window.location.protocol}//h5.${baseDomain}/?utm_source=tuijian`;
  }

  return linkConfig;
}

const sourceUrl = "_s_u_l_";
const linkConfig = createLinkConfig();
const signature = "fdfd";
export { linkConfig, sourceUrl, signature };
